import React from "react";
import { DEFAULT_BLOCK_CSS } from "../../../../constant/constant";
import { parseCssStringToObject } from "../../../../helper";
import { useApp } from "../../../../context/AppState";

const ShippingProtection = ({ section }) => {
  const { isMobile } = useApp();

  const enabled = section?.setting?.enabled ?? false;
  const protectionCost = Number(section?.setting?.cost ?? 2.99);
  const label = section?.setting?.label || "Shipping Protection";

  const blockCSS = {
    ...DEFAULT_BLOCK_CSS,
    ...section?.setting?.customCSS?.[isMobile ? "mobile" : "desktop"],
    ...parseCssStringToObject(
      section?.setting?.overrideCss?.[isMobile ? "mobile" : "desktop"]
    ),
    flexWrap: "wrap",
    whiteSpace: "pre-wrap",
    rotate:
      section?.setting?.[isMobile ? "mobile" : "desktop"]?.rotation ?? `0deg`,
  };

  return (
    <div style={blockCSS}>
      <div className="mb-2 flex w-full items-center">
        <img
          src="https://img.icons8.com/color/48/000000/shield.png"
          alt=""
          className="mr-3 h-10 w-10 shrink-0 rounded-full object-cover"
        />

        <div className="flex min-w-0 flex-1 flex-col items-start">
          <div className="flex w-full items-center justify-between">
            <span className="font-bold">{label}</span>
            <span className="font-bold">${protectionCost.toFixed(2)}</span>
          </div>

          <p
            className="mt-1 w-full text-left text-[13px] leading-snug text-neutral-600"
          >
            Protect your order from damage, loss, or theft during shipping.
          </p>
        </div>

        <span
          className="ml-2 inline-flex shrink-0 cursor-not-allowed opacity-60"
          role="switch"
          aria-checked={enabled}
          aria-label="Shipping Protection Switch"
        >
          <span
            className={`relative h-7 w-12 rounded-full transition-colors ${
              enabled ? "bg-green-500" : "bg-neutral-300"
            }`}
          >
            <span
              className="absolute top-0.5 h-6 w-6 rounded-full bg-white shadow transition-transform"
              style={{ left: enabled ? "calc(100% - 1.65rem)" : "2px" }}
            />
          </span>
        </span>
      </div>
    </div>
  );
};

export default ShippingProtection;
